import React from 'react';
import Card from "react-bootstrap/Modal";
import LinkButton from "../../utils/LinkButton";
import cursosimg from "../../static/images/cursos_default.png";

const EventItem = ({index,item, setTab, edit=true , redirect = false})=>{

    let rol = localStorage.getItem("rol");
    let pathComplement = "";
    if (rol === "company") {
      pathComplement = "/company";
    }
    if (rol === "applicant") {
      pathComplement = "/user";
    }
    if (rol === "institute") {
      pathComplement = "/CentroFormacion"
    }
    
    return(
 
        <div className="row " key={index}  >
          <div className="col-sm-6 mt-2 mb-2">
            <div className="border-gray img-Curso">
              <img
                src={
                  item.image != null
                    ?  item.image
                    : cursosimg
                }
                alt="didi"
              />
            </div>
          </div>
          <div className="col-sm-6 mt-1 mb-2">
            <p className="mb-1">
              Nombre del evento: <br></br>
              <span>{item.name}</span>
            </p>
            <p>
              descripcion: <br></br>
              <span style={{wordBreak: "break-word" }}>{item.description}</span>
            </p>
            <div className="tab2btn d-inline">
              {edit ? <LinkButton
                to={{
                  pathname: pathComplement + "/Eventos/Crear",
                  state: {
                    item,
                    redirect
                  },
                }}
                onClick={setTab}
                type="button"
                className="btn btn--gradient"
              >
                Editar
              </LinkButton>:null}
              <LinkButton
                to={{
                  pathname: pathComplement + "/DetalleEvento",
                  state: item,
                }}
                type="button"
                className="btn btn--gradient"
              >
                Ver
              </LinkButton>
            </div>
          </div>
          {/* <div className="col-sm-1 mt-2 mb-2 text-center">
            <i
              className="fas fa-trash-alt trash"
              onClick={() => modalDelete(item.courseId)}
            ></i>
          </div> */}
        </div>
    )
}

export default EventItem;